import {
  FilterType,
  buildTrainingsDataTableFilter,
  useTrainingsDataTable,
} from 'generated/resources/datatable.graphql'
import moment from 'moment'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

export const yearFilter = (source: ReturnType<typeof useTrainingsDataTable>) => {
  const currentYear = moment().year()

  const years = []
  for (let i = currentYear + 1; i >= currentYear - 25; i--) {
    years.push(i)
  }

  const options = years.map((year) => {
    return {
      label: String(year),
      value: year,
    }
  })

  return buildTrainingsDataTableFilter(source, {
    type: FilterType.Integer,
    default: false,
    categories: [
      {
        kind: 'FreeField',
        operation: 'eq',
        description: i18n.t('trainings.trainings_table.filters.year_filter.description'),
        errorMessage: i18n.t('trainings.trainings_table.filters.year_filter.error_message'),
        validation: (value: string) => /^\d{4}$/.test(value),
        options: options,
      },
    ],
    identifier: 'yearFilter2',
    path: 'year',
    title: i18n.t('trainings.create_training_modal.year'),
    onUpdateValue: () => {
      track(trackingEvents.training.trainingsFilters.yearFilter)
      track(trackingEvents.training.trainingRequest.filterPublicTrainings, {
        filter_used: 'Year',
      })
    },
  })
}
